import { produce } from 'immer'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import * as types from './types'
import _ from 'lodash';

// --- VIEW -----------------------------------------------------------------------------------
const initialGlobalState: types.GlobalViewState = {
    drawerOpen: false,
    pageTitle: 'Home',
    notifications: [],
}

const globalViewReducer = (
    state = initialGlobalState,
    action: types.GlobalViewActionTypes
) => {
    return produce(state, draft => {
        if (action.type === types.GLOBAL_SET_DRAWER) {
            draft.drawerOpen = action.open
        } else if (action.type === types.GLOBAL_CHANGE_TITLE) {
            draft.pageTitle = action.title
        } else if (action.type === types.GLOBAL_ADD_SNACKBAR) {
            draft.notifications = [...draft.notifications, action.notification]
        } else if (action.type === types.GLOBAL_CLOSE_SNACKBAR) {
            draft.notifications = draft.notifications.map(notification => {
                return (action.key === null || action.key === notification.key) ? { ...notification, dismissed: true } : { ...notification }
            })
        } else if (action.type === types.GLOBAL_REMOVE_SNACKBAR) {
            draft.notifications = draft.notifications.filter(notification => notification.key !== action.key)
        }
    })
}

// --- OPTIONS -----------------------------------------------------------------------------------
const initialOptionsState: types.GlobalOptionsState = {
    baseUrl: null,
}

const globalOptionsReducer = (
    state = initialOptionsState,
    action: types.GlobalOptionsActionTypes
) => {
    return produce(state, draft => {
        if (action.type === types.GLOBAL_CHANGE_URL) {
            draft.baseUrl = action.url
        }
    })
}

// --- GRIDS -----------------------------------------------------------------------------------
const initialGridsState: types.GlobalGridsState = {
    grids: {}
}

const globalGridsReducer = (
    state = initialGridsState,
    action: types.GlobalGridsActionTypes
) => {
    return produce(state, draft => {
        if (action.type === types.GLOBAL_SET_GRIDS) {
            draft.grids = action.grids;

        } else if (action.type === types.GLOBAL_REMOVE_GRID) {
            const { id } = action;
            const resourceName = _.keys(draft.grids).find(resource => _.keys(draft.grids[resource]).includes(id.toString()));
            if (resourceName != null) {
                delete draft.grids[resourceName][id];
                if (_.keys(draft.grids[resourceName]).length == 0) {
                    delete draft.grids[resourceName];
                }
            }

        } else if (action.type === types.GLOBAL_ADD_GRID) {
            const { grid: { resource, id }, grid } = action;
            if (draft.grids[resource] == null) {
                draft.grids[resource] = {};
            }
            draft.grids[resource][id!] = grid;
        }
    })
}

// const initialModalState: types.GlobalModalState = {
//     modalType: null,
//     modalProps: {}
// }

// --- LOGIN -----------------------------------------------------------------------------------
const initialLoginState: types.GlobalLoginState = {
    token: null
}

const loginReducer = (
    state = initialLoginState,
    action: types.GlobalAuthActionTypes
) => {
    return produce(state, draft => {
        if (action.type === types.GLOBAL_LOGIN_SUCCESS) {
            draft.token = action.token
        } else if (action.type === types.GLOBAL_LOGOUT_END) {
            draft.token = null
        }
    })
}

// -----------------------------------------------------------------------------------------------
const reducer = combineReducers({
    view: globalViewReducer,
    grids: globalGridsReducer,
    options: globalOptionsReducer,
    login: loginReducer
})

const config = {
    key: process.env.PUBLIC_URL + '/global',
    storage: storage,
    blacklist: ['modal']
}

const pReducer = persistReducer(config, reducer)

export default pReducer
